import { useAuth } from "@/contexts/AuthContext";

type PermissionValue = string;

export const usePermission = () => {
  const { permissionSet, role } = useAuth();

  const hasPermission = (permission: PermissionValue): boolean =>
    permissionSet.has(permission);

  const hasAnyPermission = (permissions: PermissionValue[]): boolean =>
    permissions.some((permission) => permissionSet.has(permission));

  const hasAllPermissions = (permissions: PermissionValue[]): boolean =>
    permissions.every((permission) => permissionSet.has(permission));

  const isOwner = (): boolean => role?.name === "OWNER";

  const isITAdmin = (): boolean => role?.name === "IT_ADMIN";

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isOwner,
    isITAdmin,
  };
};
